import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";

export interface IContract {
  id: number;
  uuid: string;
  company_id: number;
  client_id: number;
  title: string;
  description: string | null;
  start_date: string | null;
  end_date: string | null;
  value: number | null;
  currency: string;
  status: "draft" | "active" | "expired" | "cancelled" | "terminated" | "renewed";
  signed_at: string | null;
  document_url: string | null;
  created_at: string;
  updated_at: string | null;
  client_name?: string | null;
  client_email?: string | null;
}

export interface IContractCreatePayload {
  client_id: number;
  title: string;
  description?: string;
  start_date?: string;
  end_date?: string;
  value?: number;
  currency?: string;
  status?: string;
  signed_at?: string;
  document_url?: string;
}

export interface IContractUpdatePayload extends IContractCreatePayload {
  id: number;
}

export async function listContracts(qData: QData): Promise<AxiosResponse<TResponseWithQData<IContract[]>>> {
  return axios.get(API_ENDPOINTS.CONTRACT_LIST, { params: qData });
}

export async function createContract(data: IContractCreatePayload): Promise<AxiosResponse<TResponse<IContract>>> {
  return axios.post(API_ENDPOINTS.CONTRACT_CREATE, data);
}

export async function updateContract(data: IContractUpdatePayload): Promise<AxiosResponse<TResponse<IContract>>> {
  return axios.put(`${API_ENDPOINTS.CONTRACT_UPDATE}/${data.id}`, data);
}

export async function deleteContract(id: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.delete(`${API_ENDPOINTS.CONTRACT_DELETE}/${id}`);
}
